/**
 * @generated SignedSource<<eeb3f5f0c7e4c5f597cdccf0d16f309b>>
 * @relayHash 675361bd8a0cbf4e577c3d4a64e58d93
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID a053b466a5a7278a0b6b6373921b28f57107b4a597af1f3eaa118e9a60bc2b09

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { FormatRulesQuery } from './FormatRulesQuery.graphql';

const node: PreloadableConcreteRequest<FormatRulesQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "a053b466a5a7278a0b6b6373921b28f57107b4a597af1f3eaa118e9a60bc2b09",
    "metadata": {},
    "name": "FormatRulesQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
